"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypeDescriptionMap = exports.FieldGroup = exports.readonlyFields = exports.FieldType = exports.LinkFieldSet = exports.TimeFormat = exports.DateFormat = exports.DateRange = exports.CollectType = exports.SymbolAlign = exports.NumberPrecisionType = exports.DefaultCommaStyle = exports.SegmentType = exports.MentionType = exports.MemberType = exports.RollUpFuncType = exports.BasicValueType = exports.FormulaFuncType = void 0;
const i18n_1 = require("../exports/i18n");
var FormulaFuncType;
(function (FormulaFuncType) {
    FormulaFuncType["Array"] = "Array";
    FormulaFuncType["DateTime"] = "DataTime";
    FormulaFuncType["Logical"] = "Logical";
    FormulaFuncType["Numeric"] = "Numeric";
    FormulaFuncType["Record"] = "Record";
    FormulaFuncType["Text"] = "Text";
})(FormulaFuncType = exports.FormulaFuncType || (exports.FormulaFuncType = {}));
/**
  * The underlying type of the cell value.
  */
var BasicValueType;
(function (BasicValueType) {
    BasicValueType["String"] = "String";
    BasicValueType["Number"] = "Number";
    BasicValueType["DateTime"] = "DateTime";
    BasicValueType["Array"] = "Array";
    BasicValueType["Boolean"] = "Boolean";
})(BasicValueType = exports.BasicValueType || (exports.BasicValueType = {}));
var RollUpFuncType;
(function (RollUpFuncType) {
    RollUpFuncType["VALUES"] = "VALUES";
    // Take formula calculation, there is expression
    RollUpFuncType["AVERAGE"] = "AVERAGE";
    RollUpFuncType["COUNT"] = "COUNT";
    RollUpFuncType["COUNTA"] = "COUNTA";
    RollUpFuncType["COUNTALL"] = "COUNTALL";
    RollUpFuncType["SUM"] = "SUM";
    RollUpFuncType["MIN"] = "MIN";
    RollUpFuncType["MAX"] = "MAX";
    RollUpFuncType["AND"] = "AND";
    RollUpFuncType["OR"] = "OR";
    RollUpFuncType["XOR"] = "XOR";
    // Currently processed in lookup
    // // will be converted to string
    RollUpFuncType["CONCATENATE"] = "CONCATENATE";
    RollUpFuncType["ARRAYJOIN"] = "ARRAYJOIN";
    // // still an array
    RollUpFuncType["ARRAYUNIQUE"] = "ARRAYUNIQUE";
    RollUpFuncType["ARRAYCOMPACT"] = "ARRAYCOMPACT";
})(RollUpFuncType = exports.RollUpFuncType || (exports.RollUpFuncType = {}));
var MemberType;
(function (MemberType) {
    MemberType[MemberType["Team"] = 1] = "Team";
    MemberType[MemberType["Role"] = 2] = "Role";
    MemberType[MemberType["Member"] = 3] = "Member";
})(MemberType = exports.MemberType || (exports.MemberType = {}));
var MentionType;
(function (MentionType) {
    MentionType[MentionType["Unknown"] = 0] = "Unknown";
    MentionType[MentionType["User"] = 1] = "User";
    MentionType[MentionType["DataSheet"] = 2] = "DataSheet";
    MentionType[MentionType["Group"] = 3] = "Group";
})(MentionType = exports.MentionType || (exports.MentionType = {}));
var SegmentType;
(function (SegmentType) {
    SegmentType[SegmentType["Unknown"] = 0] = "Unknown";
    SegmentType[SegmentType["Text"] = 1] = "Text";
    SegmentType[SegmentType["Mention"] = 1] = "Mention";
    SegmentType[SegmentType["Url"] = 2] = "Url";
    SegmentType[SegmentType["Image"] = 3] = "Image";
    SegmentType[SegmentType["Email"] = 4] = "Email";
})(SegmentType = exports.SegmentType || (exports.SegmentType = {}));
exports.DefaultCommaStyle = ',';
var NumberPrecisionType;
(function (NumberPrecisionType) {
    NumberPrecisionType[NumberPrecisionType["level0"] = 0] = "level0";
    NumberPrecisionType[NumberPrecisionType["level1"] = 1] = "level1";
    NumberPrecisionType[NumberPrecisionType["level2"] = 2] = "level2";
    NumberPrecisionType[NumberPrecisionType["level3"] = 3] = "level3";
    NumberPrecisionType[NumberPrecisionType["level4"] = 4] = "level4";
})(NumberPrecisionType = exports.NumberPrecisionType || (exports.NumberPrecisionType = {}));
var SymbolAlign;
(function (SymbolAlign) {
    /** default */
    SymbolAlign[SymbolAlign["default"] = 0] = "default";
    /** left */
    SymbolAlign[SymbolAlign["left"] = 1] = "left";
    /** to the right */
    SymbolAlign[SymbolAlign["right"] = 2] = "right";
})(SymbolAlign = exports.SymbolAlign || (exports.SymbolAlign = {}));
var CollectType;
(function (CollectType) {
    // all fields
    CollectType[CollectType["AllFields"] = 0] = "AllFields";
    // specify the field
    CollectType[CollectType["SpecifiedFields"] = 1] = "SpecifiedFields";
})(CollectType = exports.CollectType || (exports.CollectType = {}));
var DateRange;
(function (DateRange) {
    /**
     * 1901/01/01 00:00:00 UTC+0000
     * Reason for minimum time limit
     */
    DateRange[DateRange["MinTimeStamp"] = -2177452800000] = "MinTimeStamp";
    /** 3000/12/31 24:00:00 UTC+0000 */
    DateRange[DateRange["MaxTimeStamp"] = 32535216000000] = "MaxTimeStamp";
})(DateRange = exports.DateRange || (exports.DateRange = {}));
var DateFormat;
(function (DateFormat) {
    /** year month day */
    DateFormat[DateFormat["YYYY/MM/DD"] = 0] = "YYYY/MM/DD";
    /** year month day */
    DateFormat[DateFormat["YYYY-MM-DD"] = 1] = "YYYY-MM-DD";
    /** day/month/year */
    DateFormat[DateFormat["DD/MM/YYYY"] = 2] = "DD/MM/YYYY";
    /** year-month */
    DateFormat[DateFormat["YYYY-MM"] = 3] = "YYYY-MM";
    /** Month Day */
    DateFormat[DateFormat["MM-DD"] = 4] = "MM-DD";
    /** year */
    DateFormat[DateFormat["YYYY"] = 5] = "YYYY";
    /** month */
    DateFormat[DateFormat["MM"] = 6] = "MM";
    /** day */
    DateFormat[DateFormat["DD"] = 7] = "DD";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var TimeFormat;
(function (TimeFormat) {
    /** 'HH:mm', 00 - 24 hour */
    TimeFormat[TimeFormat["HH:mm"] = 0] = "HH:mm";
    /** 'hh:mm', 00 - 12 hour */
    TimeFormat[TimeFormat["hh:mm"] = 1] = "hh:mm";
})(TimeFormat = exports.TimeFormat || (exports.TimeFormat = {}));
var LinkFieldSet;
(function (LinkFieldSet) {
    LinkFieldSet["Add"] = "add";
})(LinkFieldSet = exports.LinkFieldSet || (exports.LinkFieldSet = {}));
var FieldType;
(function (FieldType) {
    FieldType[FieldType["NotSupport"] = 0] = "NotSupport";
    FieldType[FieldType["Text"] = 1] = "Text";
    FieldType[FieldType["Number"] = 2] = "Number";
    FieldType[FieldType["SingleSelect"] = 3] = "SingleSelect";
    FieldType[FieldType["MultiSelect"] = 4] = "MultiSelect";
    FieldType[FieldType["DateTime"] = 5] = "DateTime";
    FieldType[FieldType["Attachment"] = 6] = "Attachment";
    FieldType[FieldType["Link"] = 7] = "Link";
    FieldType[FieldType["URL"] = 8] = "URL";
    FieldType[FieldType["Email"] = 9] = "Email";
    FieldType[FieldType["Phone"] = 10] = "Phone";
    FieldType[FieldType["Checkbox"] = 11] = "Checkbox";
    FieldType[FieldType["Rating"] = 12] = "Rating";
    FieldType[FieldType["Member"] = 13] = "Member";
    FieldType[FieldType["LookUp"] = 14] = "LookUp";
    // RollUp = 15,
    FieldType[FieldType["Formula"] = 16] = "Formula";
    FieldType[FieldType["Currency"] = 17] = "Currency";
    FieldType[FieldType["Percent"] = 18] = "Percent";
    FieldType[FieldType["SingleText"] = 19] = "SingleText";
    FieldType[FieldType["AutoNumber"] = 20] = "AutoNumber";
    FieldType[FieldType["CreatedTime"] = 21] = "CreatedTime";
    FieldType[FieldType["LastModifiedTime"] = 22] = "LastModifiedTime";
    FieldType[FieldType["CreatedBy"] = 23] = "CreatedBy";
    FieldType[FieldType["LastModifiedBy"] = 24] = "LastModifiedBy";
    FieldType[FieldType["Cascader"] = 25] = "Cascader";
    // Workdoc = 27,
    FieldType[FieldType["DeniedField"] = 999] = "DeniedField";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
exports.readonlyFields = new Set([
    FieldType.Formula,
    FieldType.LookUp,
    FieldType.AutoNumber,
    FieldType.CreatedTime,
    FieldType.LastModifiedTime,
    FieldType.CreatedBy,
    FieldType.LastModifiedBy,
]);
var FieldGroup;
(function (FieldGroup) {
    FieldGroup[FieldGroup["Common"] = 0] = "Common";
    FieldGroup[FieldGroup["Advanced"] = 1] = "Advanced";
})(FieldGroup = exports.FieldGroup || (exports.FieldGroup = {}));
/**
 * Fields description
 */
exports.FieldTypeDescriptionMap = {
    [FieldType.DeniedField]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_single_text),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_single_text),
        type: FieldType.SingleText,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_text),
        hasOptSetting: false,
    },
    [FieldType.SingleText]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_single_text),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_single_text),
        type: FieldType.SingleText,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_single_text),
        hasOptSetting: true,
    },
    [FieldType.Text]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_text),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_text),
        type: FieldType.Text,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_text),
        hasOptSetting: false,
    },
    [FieldType.Number]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_number),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_number),
        type: FieldType.Number,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_number),
        hasOptSetting: true,
    },
    [FieldType.SingleSelect]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_single_select),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_single_select),
        type: FieldType.SingleSelect,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_single_select),
        hasOptSetting: true,
    },
    [FieldType.MultiSelect]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_multi_select),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_multi_select),
        type: FieldType.MultiSelect,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_multi_select),
        hasOptSetting: true,
    },
    [FieldType.DateTime]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_datetime),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_datetime),
        type: FieldType.DateTime,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_datetime),
        hasOptSetting: true,
    },
    [FieldType.Attachment]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_attachment),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_attachment),
        type: FieldType.Attachment,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_attachment),
        hasOptSetting: false,
    },
    [FieldType.Link]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_link),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_link),
        type: FieldType.Link,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_link),
        hasOptSetting: true,
    },
    [FieldType.LookUp]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_lookup),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_lookup),
        type: FieldType.LookUp,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_lookup),
        hasOptSetting: true,
    },
    [FieldType.Formula]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_formula),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_formula),
        type: FieldType.Formula,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_formula),
        hasOptSetting: true,
    },
    [FieldType.Member]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_member),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_member),
        type: FieldType.Member,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_member),
        hasOptSetting: true,
    },
    [FieldType.Checkbox]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_checkbox),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_checkbox),
        type: FieldType.Checkbox,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_checkbox),
        hasOptSetting: true,
    },
    [FieldType.Rating]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_rating),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_rating),
        type: FieldType.Rating,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_rating),
        hasOptSetting: true,
    },
    [FieldType.URL]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_url),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_url),
        type: FieldType.URL,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_url),
        hasOptSetting: false,
    },
    [FieldType.Phone]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_phone),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_phone),
        type: FieldType.Phone,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_phone),
        hasOptSetting: false,
    },
    [FieldType.Email]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_email),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_email),
        type: FieldType.Email,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_email),
        hasOptSetting: false,
    },
    [FieldType.Currency]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_currency),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_currency),
        type: FieldType.Currency,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_currency),
        hasOptSetting: true,
    },
    [FieldType.Percent]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_percent),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_percent),
        type: FieldType.Percent,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Common,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_percent),
        hasOptSetting: true,
    },
    [FieldType.AutoNumber]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_autonumber),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_autonumber),
        type: FieldType.AutoNumber,
        canBePrimaryField: true,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_autonumber),
        hasOptSetting: false,
    },
    [FieldType.CreatedTime]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_created_time),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_created_time),
        type: FieldType.CreatedTime,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_created_time),
        hasOptSetting: true,
    },
    [FieldType.LastModifiedTime]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_last_modified_time),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_last_modified_time),
        type: FieldType.LastModifiedTime,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_last_modified_time),
        hasOptSetting: true,
    },
    [FieldType.CreatedBy]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_created_by),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_created_by),
        type: FieldType.CreatedBy,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_created_by),
        hasOptSetting: true,
    },
    [FieldType.LastModifiedBy]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_last_modified_by),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_last_modified_by),
        type: FieldType.LastModifiedBy,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_last_modified_by),
        hasOptSetting: true,
    },
    [FieldType.Cascader]: {
        title: (0, i18n_1.t)(i18n_1.Strings.field_title_tree_select),
        subTitle: (0, i18n_1.t)(i18n_1.Strings.field_desc_cascader),
        type: FieldType.Cascader,
        canBePrimaryField: false,
        fieldGroup: FieldGroup.Advanced,
        help: (0, i18n_1.t)(i18n_1.Strings.field_help_cascader),
        hasOptSetting: true,
    },
};
//# sourceMappingURL=field_types.js.map